@if (showGlobalSpinner) {
  <div class="dialog-spinner">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}

<div class="adhoc-upload-dialog">
  <!-- Header -->
  <div class="dialog-header">
    <div class="dialog-title">Upload Ad-Hoc Notifications File</div>
    <button type="button" class="dialog-close-bt" aria-label="Close dialog" (click)="close()">✕</button>
  </div>
  <!-- Body -->
  <div class="dialog-body">
    <!-- Selected file (readonly) -->
    <div class="field">
      <label class="field-label">Selected file</label>
      <div class="file-row">
        <input class="file-name-input" type="text" [value]="fileName || ''" placeholder="No file selected" readonly />
        <button class="choose-btn adhoc-primary-btn" mat-raised-button type="button" (click)="openFilePicker()">
          Choose File
        </button>
        <div class="file-row-icon-actions">
          <button class="icon-btn" matTooltip="Clear" matTooltipPosition="above" mat-icon-button type="button"
            aria-label="Clear selected file"
            (click)="resetFileSelection()" [disabled]="!fileName">
            <mat-icon color="warn">close</mat-icon>
          </button>
          <button class="icon-btn icon-btn-upload" matTooltip="Upload" matTooltipPosition="above" mat-icon-button
            type="button" aria-label="Upload selected file" (click)="uploadFile()" [disabled]="disableUploadCta">
            <mat-icon [class.upload-icon-ready]="!disableUploadCta && !showGlobalSpinner">done</mat-icon>
          </button>
        </div>
      </div>
      <!-- Hidden native input (NO duplicate UI) -->
      <input #fileInput class="native-file-input" type="file" accept=".csv" (change)="uploadFileEvt($event)" />
      <div class="note">
        <span>Note: Upload only csv file up to 700 KB. </span>
        <a [href]="templateCsvHref" download="AdhocNotification.csv" class="template-download-link">Click here</a>
        <span> to download the CSV template.</span>
      </div>
      @if (fileNameMismatch) {
        <div class="msg error">
          {{ invalidFileMessage }}
        </div>
      }
      @if (fileError) {
        <div class="msg error">
          {{ invalidFileMessage }}
        </div>
      }
    </div>
    <!-- Errors -->
    @if (invalidEvents?.length) {
      <div class="msg error strong">
        The Ad-Hoc notifications were not sent/scheduled due to the following errors.
      </div>
      <div class="errors-box">
        <div class="errors-scroll">
          @for (invalidEvent of invalidEvents; track invalidEvent) {
            <div class="error-item">
              • {{ invalidEvent?.rowNumber }}, {{ invalidEvent?.errorMsg || 'N/A' }}
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>